<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Pedido</p>
              <div class="ms-auto">
              <argon-button v-if="form.status === 0" color="success"
                size="sm" @click="save" style="margin-right: 10px;">Guardar</argon-button>
              <argon-button v-if="form.id != 0 && form.status === 0" color="success"
                size="sm" @click="asentar">Asentar</argon-button>
              </div>
              
            </div>
          </div>
          <div class="card-body">
            <div class="row">

              <div class="col-md-6">
                <label for="document-type" class="form-control-label">Tipo de Documento</label>
                <select id="documentType" class="form-control" v-model="form.document_type" :disabled="isRemissionAsentada">
                  <option value="" disabled>Seleccione un tipo de documento</option>
                  <option value="CC">Cédula de Ciudadanía (CC)</option>
                  <option value="CE">Cédula de Extranjería (CE)</option>
                  <option value="TI">Tarjeta de Identidad (TI)</option>
                  <option value="RC">Registro Civil (RC)</option>
                  <option value="PA">Pasaporte (PA)</option>
                  <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                  <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                </select>
              </div>

             <div class="col-md-6">
              <label for="document-input" class="form-control-label">Número documento</label>
              <input
                id="document-input"
                type="text"
                class="form-control"
                v-model="form.document"
                @blur="getClient()"
                autocomplete="off"
                :disabled="isRemissionAsentada"
              />
            </div>

              <div class="col-md-6" style="position: relative;">
                <label for="example-text-input" class="form-control-label">Nombre</label>
                <argon-input type="text" v-model="form.name" :disabled="isRemissionAsentada" />
              </div>

              

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Dirección</label>
                <argon-input type="text" v-model="form.address" autocomplete="off" :disabled="isRemissionAsentada" />
              </div>


              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Telefono</label>
                <argon-input type="text" v-model="form.phone" :disabled="isRemissionAsentada" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Email</label>
                <argon-input type="text" v-model="form.email" :disabled="isRemissionAsentada" />
              </div>

              
              <div class="col-md-6">
                <label for="example-select-input" class="form-control-label">Metodo de pago</label>
                <select v-model="form.method_payment" class="form-control" :disabled="isRemissionAsentada">
                  <option value="EF">Efectivo</option>
                  <option value="CR">Credito</option>
                </select>
              </div>
              


              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Observación</label>
                <ArgonTextarea type="text" v-model="form.observation" :disabled="isRemissionAsentada" />
              </div>


            </div>
          </div>
        </div>
      </div>

       <div class="col-md-4" v-if="form.id != 0">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Detalles de vehículo</p>
              <argon-button color="success" v-if="form.status==0"
                size="sm" class="ms-auto" @click="saveVehicle">Guardar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12" style="position: relative;">
                <label for="example-text-input" class="form-control-label">No.MC</label>
                <argon-input type="text" v-model="vehicle.number" :disabled="isRemissionAsentada" />
              </div>
             <div class="col-md-12" style="position: relative;">
              <label for="plate-input" class="form-control-label">Placa</label>
              <input
                id="plate-input"
                type="text"
                class="form-control"
                v-model="vehicle.plate"
                style="text-transform: uppercase;"
                :disabled="isRemissionAsentada"
              />
            </div>
              <div class="col-md-12" style="position: relative;">
                <label for="example-text-input" class="form-control-label">Toneladas Tara</label>
                <argon-input type="text" v-model="vehicle.tons_tara" :disabled="isRemissionAsentada" />
              </div>
              <div class="col-md-12" style="position: relative;">
                <label for="example-text-input" class="form-control-label">Toneladas Neto</label>
                <argon-input type="text" v-model="vehicle.tons" :disabled="isRemissionAsentada" />
              </div>
               <div class="col-md-12" style="position: relative;">
                <label for="example-text-input" class="form-control-label">Toneladas Total</label>
                <argon-input type="text" v-model="vehicle.tons_total" disabled/>
              </div>

            </div>
          </div>
        </div>
      </div>


      <div class="col-md-12">
        <div class="card" v-if="form.id != 0">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Lista de detalles</p>
              <div class="ms-auto">
              
              <argon-button v-if="user.role === '1' && form.status==0" color="success" size="sm"
                @click="addDetail">Agregar producto</argon-button>
              </div>
             
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Producto</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Bodega
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Cantidad
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Obsequios
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Precio
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Total
                      </th>
                      <th v-if="form.status<1" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                        Opciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="value in data.data" :key="value.id">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="">
                            <h6 class="mb-0 text-sm">{{ value?.inventory?.name ?? 'No encontrado' }}</h6>
                              <span class="badge badge-sm bg-gradient-success">
                              En stock: {{ value?.inventory?.stock_total ?? '0' }}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ value.bodega?.name ?? "No encontrado" }}
                      </td>

                      <td class="align-middle text-center">
                        <input type="text"
                              v-model.number="value.quantity"
                              class="form-control form-control-sm text-center"
                              min="0" @blur="updateDetail(value)"
                              :disabled="isRemissionAsentada"/>
                      </td>

                      <td class="align-middle text-center">
                        <input type="text"
                              v-model.number="value.obsequios"
                              class="form-control form-control-sm text-center"
                              min="0" @blur="updateDetail(value)"
                              :disabled="isRemissionAsentada"/>
                      </td>
                     
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.price ?? 0).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                      <td class="align-middle text-center">

                        <!--
                        <a @click="editRegister(value)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                           data-toggle="tooltip" data-original-title="Eliminar registro">
                          <i class="fa fa-pencil-alt"></i>
                        </a>
                        -->

                        <a v-if="form.status<1" @click="deleteRegister(value.id)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                          data-toggle="tooltip" data-original-title="Eliminar registro">
                          <i class="fa fa-trash"></i>
                        </a>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal agregar detalles de Pedido -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar producto</h5>
            <button type="button" class="btn-close" @click="submitForm" ></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Producto</label>
                <select ref="ProductionSelect" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Bodega Inicial</label>
                <select ref="BodegaSelect" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Bodega Final</label>
                <select ref="BodegaFinalSelect" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad</label>
                <input type="text" v-model="modal.quantity" id="total_price" class="form-control"
                  placeholder="Ingrese el valor total">
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Precio Unidad</label>
                <input type="text" v-model="formattedPrice" id="amount" class="form-control"
                  placeholder="Ingrese el valor">
              </div>
              <div class="mb-3">
                <label for="amount" class="form-label">Total</label>
                <input type="text" v-model="totalPrice" id="total_price" class="form-control"
                  placeholder="Ingrese el valor total">
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';


const body = document.getElementsByTagName("body")[0];

export default {
  name: "Remissions Create",
  data() {
    return {
      showMenu: false,
      modalBudget: null,
      isFinish: false,
      filter: {
        production_id: [],
        model_id: [],
        oficio_id: [],
        user_id: [],
      },
      models: [],
      user: {},
      form: {
        id: 0,
        name: '',
        document_type:'CC',
        document:'',
        address:'',
        phone: '',
        email: '',
        observation: '',
        status: 0,
        type:'production',
        check_averias:0,
        method_payment:'EF'
      },
      vehicle: {
        id: 0,
        remission_id: 0,
        plate: '',
        number: '',
        tons_tara:0,
        tons:0,
        tons_total:0,
      },
      data: [],
      modal: {
        id: 0,
        remission_id: 0,
        inventory_id: 0,
        bodega_id: 0,
        bodega_final_id:0,
        quantity: 0,
        price: 0,
        total: 0
      },
      modalEvidencia: [],
      suppliers: [],
      filteredSuppliers: [],
      users: [],
    };
  },
  components: { ArgonInput, ArgonButton, ArgonTextarea },
  computed: {
    isRemissionAsentada() {
      return this.form.status === 1;
    },
    formattedPrice: {
      get() {
        return this.modal.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.modal.price = Math.floor(value.replace(/\./g, "") || 0);
        this.modal.total = Math.floor(this.modal.price * this.modal.quantity);
      },
    },
    totalPrice: {
      get() {
        return this.modal.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.modal.total = Math.floor(value.replace(/\./g, "") || 0);
        this.modal.price = this.modal.quantity > 0 ? Math.floor((this.modal.total / this.modal.quantity)) : 0;
      },
    },
  },
  watch: {
    "vehicle.tons_tara"(newTara) {
      const tons = parseFloat(this.vehicle.tons) || 0;
      const tara = parseFloat(newTara) || 0;
      this.vehicle.tons_total = tons - tara;
    },
    "vehicle.tons"(newTons) {
      const tara = parseFloat(this.vehicle.tons_tara) || 0;
      const tons = parseFloat(newTons) || 0;
      this.vehicle.tons_total = tons - tara;
    },
    "modal.quantity"(newQuantity) {

      console.log('newQuantity', newQuantity);
      const selectedOption = $(this.$refs.BodegaSelect).find('option:selected');
      const quantity = selectedOption.data('quantity');

      console.log('quantity', quantity);


      if (newQuantity > quantity) {
        this.modal.quantity = quantity;
      }
      
      this.modal.total = Math.floor(this.modal.price * newQuantity);
    },
  },
  methods: {
    async getProductions() {

      this.productions = await this.$store.dispatch('inventory/getAll', this.form.id);

      this.$nextTick(async () => {

        const select = $(this.$refs.ProductionSelect);

        // Destruir select2 si ya está inicializado
        if (select.hasClass("select2-hidden-accessible")) {
          select.select2('destroy');
        }

        select.empty();

        select.append('<option value="" disabled selected>Seleccionar Producción</option>');
        this.productions.forEach(prod => {
          if(prod.stock_total>0){
            this.data?.data?.forEach(detail => {
              if (detail.inventory_id == prod.id) {
                prod.stock_total = prod.stock_total - detail.quantity - detail.averia - detail.segunda - detail.tercera - detail.obsequios;
              }
            });
            if(prod.stock_total>0){
              select.append(new Option(`#${prod.ref} - ${prod.name} (${parseInt(prod.stock_total)})`, prod.id, false, false));
            }
          }
        });

        $(this.$refs.ProductionSelect).select2({
          placeholder: 'Seleccionar producto',
          allowClear: false,
          dropdownParent: $('#ModalBudget .modal-body')
        });

        $(this.$refs.ProductionSelect).on('change', async () => {
          const product_id = $(this.$refs.ProductionSelect).val();
          this.modal.inventory_id = product_id;

          const product = this.productions?.find(prod => prod.id == product_id );

          await this.getBodegas(product);
        })
      });
    },
    async getBodegas(Bodegas) {
      let bodegas  = Bodegas.bodegas_inventory;

      const select = $(this.$refs.BodegaSelect);

      if (select.hasClass("select2-hidden-accessible")) {
        select.select2('destroy');
      }
      select.empty();
      select.append('<option value="" disabled selected>Seleccionar referencia</option>');
      bodegas.forEach(prod => {

        // if(prod.code!='Produccion' || prod.code!='Despacho'){
        //   return;
        // }
        const option = new Option(
          `#${prod?.bodega?.name} (${prod.quantity})`, 
          prod.bodega_id,
          false,
          false
        );
        
        // aquí sí agregas el data a la opción
        $(option).attr('data-quantity', prod.quantity);

        select.append(option);

      });

      $(this.$refs.BodegaSelect).select2({
        placeholder: 'Seleccione una bodega',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body')
      });

      $(this.$refs.BodegaSelect).on('change', () => {
        this.modal.bodega_id = $(this.$refs.BodegaSelect).val();
      });

      /** BODEGA FINAL */
      let bodegasFinal = await this.$store.dispatch('bodegas/getAll');
      const selectFinal = $(this.$refs.BodegaFinalSelect);

      if (selectFinal.hasClass("select2-hidden-accessible")) {
        selectFinal.select2('destroy');
      }
      selectFinal.empty();
      selectFinal.append('<option value="" disabled selected>Seleccionar referencia</option>');
      bodegasFinal.forEach(prod => {

        if(prod.code!=17){
          return;
        }
        
        const option = new Option(
          `#${prod?.name}`, 
          prod.id,
          false,
          false
        );
        
        selectFinal.append(option);

      });

      $(this.$refs.BodegaFinalSelect).select2({
        placeholder: 'Seleccione una bodega',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body')
      });

      $(this.$refs.BodegaFinalSelect).on('change', () => {
        this.modal.bodega_final_id = $(this.$refs.BodegaFinalSelect).val();
      });


    },
    addDetail() {
      this.modal.id = 0;
      this.modal.production_id = 0;
      this.modal.model_id = 0;
      this.modal.quantity = 0;
      this.modal.price = 0;
      this.modal.total = 0;

      this.getProductions();
      $(this.$refs.ModelSelect).val("").trigger('change');

      this.openModal();
    },
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
    },
    async getData() {
      this.data = await this.$store.dispatch('remissionsDetails/getData', this.form.id);
    },
    async confirm() {
      await Swal.fire({
        icon: 'info',
        title: 'Formalizar compra',
        text: 'Al formalizar la compra ya no se podra editar los registros ni los detalles de la compra',
        confirmButtonText: 'Aceptar',
        backdrop: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.form.status = 1;
          this.save();
        }
      });
    },
    async save(ignoreStatusCheck = false) {
      if (!ignoreStatusCheck && this.isRemissionAsentada) {
        return;
      }
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("remissions/save", this.form);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.form = response.data;
              this.form.id = response.data.id || 0;
              this.modal.remission_id = response.data.id || 0;
              this.vehicle.remission_id = response.data.id || 0;

              this.getProductions();

            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async asentar() {
      try {
        // Validar que haya detalles antes de asentar
        if (!this.data.data || this.data.data.length === 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'Debe agregar al menos un producto antes de asentar la remisión.',
          });
          return;
        }

        // Primero mostrar confirmación
        const confirmResult = await Swal.fire({
          icon: 'warning',
          title: 'Confirmar Asentado',
          text: 'Al asentar la remisión se descontará de la bodega de origen las cantidades digitadas (cantidad + obsequios) y se sumarán a la bodega final. Esta acción no se puede deshacer.',
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          backdrop: true,
        });
        
        if (!confirmResult.isConfirmed) {
          // Si cancela, no hacer nada
          return;
        }

        // Preparar los datos con status = 1
        const formData = {
          ...this.form,
          status: 1
        };

        // Llamar directamente al store para actualizar con status = 1
        const response = await this.$store.dispatch("remissions/save", formData);
        
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'La remisión ha sido asentada correctamente. El inventario ha sido actualizado.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              // Actualizar el formulario con la respuesta del servidor
              this.form = response.data;
              this.form.id = response.data.id || 0;
              this.modal.remission_id = response.data.id || 0;
              this.vehicle.remission_id = response.data.id || 0;

              // Recargar los datos para reflejar los cambios
              this.getData();
            }
          });
        } else {
          throw new Error(response.data?.message || 'Error al asentar la remisión');
        }
      } catch (error) {
        console.error("Error al asentar la remisión:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al asentar la remisión',
        });
      }
    },
    async saveVehicle() {
      if (this.isRemissionAsentada) {
        return;
      }
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("remissionsVehicles/save", this.vehicle);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              console.log('vehiculo', response.data);
            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async submitForm() {
      if (this.isRemissionAsentada) {
        return;
      }
      try {
        // Dispara la acción de Vuex para guardar el modal
        const response = await this.$store.dispatch("remissionsDetails/save", this.modal);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.modal.id = 0;
              this.modal.production_id = 0;
              this.modal.model_id = 0;
              this.modal.quantity = 0;
              this.modal.price = 0;
              this.modal.total = 0;

              $(this.$refs.processesSelect).val('').trigger('change');
              $(this.$refs.BodegaSelect).val('').trigger('change');

              this.getData();
              this.closeModal();
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async editRegister(params) {
      this.modal = params;

      this.modal.id = params.id;
      this.modal.produccion = params.production_id;
      this.modal.model = params.model_id;

      $(this.$refs.ProductionSelect).val(params.production_id).trigger('change');

      this.openModal();

      await new Promise(resolve => setTimeout(resolve, 1000));

      $(this.$refs.ModelSelect).val(params.model_id).trigger('change');
      this.modal.quantity = params.quantity;
      this.modal.price = params.price;
      this.modal.total = params.total;

      console.log( this.modal );
    
    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("remissionsDetails/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async getUsers() {
      this.users = await this.$store.dispatch('users/getAll', 'all');
    },
    async getClient(){
      console.log(this.users);
      console.log(this.form);
      const client = this.users.find(h => h.document_type === this.form.document_type && h.document === this.form.document);
      if(client){
        this.form.name = client.name;
        this.form.address = client.address;
        this.form.phone = client.phone;
        this.form.email = client.email;
      }
    },
    async updateDetail(value){

      if(this.form.status==1){
        return;
      }

      const total = (parseInt(value.quantity || 0) + parseInt(value.averia || 0) + parseInt(value.segunda || 0) + parseInt(value.tercera || 0) + parseInt(value.obsequios || 0));
      if(total>value?.inventory?.stock_total){
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'La suma de las cantidades no puede ser mayor al stock disponible.',
        });
        return;
      }
  
      try {
        const response = await this.$store.dispatch("remissionsDetails/save", value);
        console.log(response);
      } catch (error) {
        console.error("Error al crear el registro:", error);
      }
    }
  },
  mounted() {
  
    this.getUsers();

    this.user = JSON.parse(localStorage.getItem('user'));
    const route = useRoute();
    const dataEdit = route.params.data;

    if (dataEdit) {

      this.getProductions();

      try {
        const params = JSON.parse(dataEdit); // Asegúrate de que este JSON se pueda parsear
        this.data = params;
        if (params && params.id) {

          this.form.id = params.id || 0;
          this.form.name = params.name || '';
          this.form.document_type = params.document_type || '';
          this.form.document = params.document || '';
          this.form.address = params.address || '';
          this.form.phone = params.phone || '';
          this.form.email = params.email || '';
          this.form.type = params.type || 'production';
          this.form.observation = params.observation || '';
          this.form.status = params.status || 0;
          this.form.check_averias = params.check_averias || 0;

          this.vehicle = params.vehicle || {
            id: 0,
            remission_id: params.id,
            plate: '',
            number: '', 
            tons:0,
          };

          

          this.modal.remission_id = params.id || 0;

          this.getData();
        }
      } catch (error) {
        console.error("Error al parsear los datos del registro:", error);
      }
    }
    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}
</style>
